module.exports = __webpack_public_path__ + "img/jiaoda.ae88caac.png";